module.exports = __webpack_public_path__ + "img/college6.9ee9d919.png";